// extracted by mini-css-extract-plugin
export var brand = "_2s-8";
export var compact = "_2s-5";
export var extraSmall = "_2s-6";
export var icon = "_2s-0";
export var large = "_2s-3";
export var light = "_2s-1";
export var medium = "_2s-4";
export var outline = "_2s-a";
export var primaryDark = "_2s-9";
export var primaryLight = "_2s-7";
export var primaryModern = "_2s-b";
export var success = "_2s-2";